export default "/images/vendor/geoportal-extensions-openlayers/src/OpenLayers/CSS/close-emeraud.svg?d1812e59c249fcd25762ead7c2d50fd4";